import React, { Component } from 'react';
import { message } from 'antd';
import TableC from '../../basicElement/TableC';
import API_URL from '../../../common/url';
import Fetch from '../../../common/Fetch';
import Filter from './Filter';
import { SelectStatisticsDs } from './Widget';
import format from '../../shared/format';
import SideNav from '../SideNav';
import moment from 'moment';
import '../style.less';

const statisticsTypes = {
    Service_Type: {
        name: '服务费类型',
    },
    BelongingToUnit: {
        name: '收入归属单位',
    },
    Lines_Of_Business: {
        name: '业务线',
    },
    Investigation_Medicine_Type: {
        name: '研究产品类型',
        checked: false,
        checkName: '细化至项目分期',
        checkValue: 'Investigation_Medicine_Type_Detail',
    },
    Investigation_Medicine_Type_Detail: {
        name: '研究产品类型(项目分期)',
        isListItem: false
    },
    Contract_Type: {
        name: '计收入确认方式',
    }
};
const statisticsDsList = ((obj) => {
    const result = [];
    for (let [key, value] of Object.entries(obj)) {
        const { name, isListItem = true, ...rest } = value;
        if(isListItem) {
            result.push({
                value: key,
                name,
                ...rest,
            });
        }
    }
    return result;
})(statisticsTypes);
const requestValue = (arr) => {
    const params = {};
    arr.forEach((a, i) => params[`arrays[${i}]`] = a.checked ? a.checkValue : a.value);
    return params;
};

class OrderChangeReport extends Component {
    constructor(props) {
        super(props);
        const searchParams = {
            selected: [{
                value: 'Service_Type',
                name: '服务费类型',
            }],
        };
        this.state = {
            searchParams,
            curParams: {...searchParams},
            loading: false,
            data: [],
            columnsTitle: [],
            endMonth: '',
            startMonth: '',
            operable: false,
        };
    }

    componentDidMount() {
        this.queryFixedLineTime();
    }

    queryFixedLineTime = () => {
        Fetch.post(API_URL.finance.queryFixedLineTime).then(res => {
            const { data } = res;
            if (!data || data.length === 0) {
                this.setState({ operable: false });
                return;
            }
            const { searchParams } = this.state;
            const startMonth = moment(format('month', data[0].year, data[0].month)).format('YYYY-MM');
            const endMonth = moment(format('month', data[data.length - 1].year, data[data.length - 1].month)).format('YYYY-MM');
            searchParams.startDate = moment(endMonth).subtract(1, 'M').format('YYYY-MM');
            searchParams.endDate = endMonth;
            this.setState({
                endMonth,
                startMonth,
                searchParams,
                operable: true,
                curParams: searchParams,
            }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        const { curParams } = this.state;
        const { selected, ...rest } = curParams;
        this.setState({ loading: true });
        Fetch.post(API_URL.finance.queryOrderInHandChangeList, {
            ...rest,
            ...requestValue(selected),
        }).then(res => {
            const { data } = res;
            const { datas, ...rest } = data;
            const { curParams: { endDate } } = this.state;
            const [{ monthOrderInHandList } = {}] = datas || [];
            rest.name = '合计';
            const newData = (datas || []);
            newData.push(rest);
            const columnsTitle = (monthOrderInHandList || []).map((item, index) => ({
                title: `Y${item.year}${index === 0 && !(endDate || '').endsWith('12') ? '剩余' : ''}在手订单额`,
                dataIndex: `${item.year}`,
                key: `${item.year}`,
                width: 120,
                render: this.getRender,
            }));
            this.setState({
                data: newData,
                loading: false,
                columnsTitle,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { searchParams } = this.state;
        this.setState({ curParams: searchParams }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { curParams } = this.state;
        const { selected, ...rest } = curParams;
        Fetch.post(API_URL.finance.exportOrderInHandChangeList, {
            ...rest,
            ...requestValue(selected),
            offset: 1,
        }).then(res => {
            message.success(res.success);
        });
    }

    getRender = (text, record, key) => {
        const { colSpan, colSpanO, statisticsDs } = record;
        const obj = {
            children: text,
            props: {},
        };
        if (key === 'name') {
            obj.props.colSpan = colSpan;
        } else {
            obj.props.colSpan = colSpanO;
        }
        if (key === 'name') {
            obj.children = <strong>{text}</strong>;
        } else if (statisticsDs === '合计') {
            obj.children = <strong>{format('money', text)}</strong>;
        } else {
            obj.children = format('money', text);
        }
        return obj;
    }

    getColumns = () => {
        const { curParams, columnsTitle } = this.state;
        const { startDate, endDate } = curParams;
        const columns = [{
            title: '数据分析维度',
            dataIndex: 'name',
            key: 'name',
            width: 260,
            render: (text, record) => this.getRender(text, record, 'name'),
        }, {
            title: `${startDate ? startDate.replace('-', '') : ''}在手订单额/人民币`,
            dataIndex: 'startYearMonthOrders',
            key: 'startYearMonthOrders',
            width: 120,
            render: this.getRender,
        }, {
            title: '补充合同增加金额/人民币(不含税)',
            dataIndex: 'supplementContractOrdersAdd',
            key: 'supplementContractOrdersAdd',
            width: 120,
            render: this.getRender,
        }, {
            title: '补充合同减少金额/人民币(不含税)',
            dataIndex: 'supplementContractOrdersReduce',
            key: 'supplementContractOrdersReduce',
            width: 120,
            render: this.getRender,
        }, {
            title: '新签署合同金额/人民币(不含税)',
            dataIndex: 'newContract',
            key: 'newContract',
            width: 120,
            render: this.getRender,
        }, {
            title: '确认收入(不含税)',
            dataIndex: 'recognitionOfRevenue',
            index: 'recognitionOfRevenue',
            width: 120,
            render: this.getRender,
        }, {
            title: '补充合同确认收入(不含税)',
            dataIndex: 'supplementContractRevenue',
            index: 'supplementContractRevenue',
            width: 120,
            render: this.getRender,
        }, {
            title: '新签署合同确认收入(不含税)',
            dataIndex: 'newContractRevenue',
            key: 'newContractRevenue',
            width: 120,
            render: this.getRender,
        }, {
            title: '差异',
            dataIndex: 'difference',
            key: 'difference',
            width: 120,
            render: this.getRender,
        }, {
            title: `${endDate ? endDate.replace('-', '') : ''}在手订单额/人民币`,
            dataIndex: 'endYearMonthOrders',
            key: 'endYearMonthOrders',
            width: 120,
            render: this.getRender,
        }];
        columns.push(...columnsTitle);
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = [];
        this.loopData(dataSource, data, 1, '', this.getColumns().length);
        return dataSource;
    }

    // 获取行数据
    getParams = (id, data, deep, colSpan, merge) => {
        const { code, monthOrderInHandList } = data;
        const { name } = statisticsTypes[code] || {};
        let otherParams;
        if (merge) {
            otherParams = {
                name: `${deep}-${name}`,
                colSpan,                     // 数据维度字段统一合并列数
                colSpanO: 0,                 // 数据维度外字段统一合并列数
                color: `orderChangeReport_${deep}`,
            };
        } else {
            otherParams = {
                ...data,
                colSpan: 1,
                colSpanO: 1,
            };
        }
        const params = {
            orderChangeReportId: id,
            ...otherParams
        };
        (monthOrderInHandList || []).map(i => {
            params[i.year] = i.value;
        });
        return params;
    }

    /**
     * 生成列表数据
     * @param {*} result 返回结果
     * @param {*} data 数据项
     * @param {*} deep 深度
     * @param {*} order key值
     * @param {*} colSpan 列合并值
     */
    loopData = (result, data, deep, order, colSpan) => {
        let key = 1;
        (data || []).forEach((item, index) => {
            const { datas, ...rest } = item;
            if (index === 0) {
                result.push(this.getParams(order + key++, rest, deep, colSpan, true));
            }

            let newOrder = order + key++;
            const params = this.getParams(newOrder, rest, deep, colSpan, false);
            result.push(params);
            if (datas && datas.length > 0) {
                params.children = [];
                this.loopData(params.children, datas, deep + 1, newOrder, colSpan);
            }
        });
    }

    changeSearchParams = (params) => {
        const { searchParams } = this.state;
        this.setState({ searchParams: { ...searchParams, ...params } });
    }

    showStatisticsDs = () => {
        const { searchParams: { selected } } = this.state; 
        this.showStatisticsDsRef.show(selected);
    } 

    render() {
        const { loading, searchParams, startMonth, endMonth, operable } = this.state;
        const scrollY = (document.body || document.documentElement).clientHeight - 150;
        return (
            <div className="content">
                <SideNav selectKey="orderChangeReport" />
                <div className="main">
                    <Filter
                        operable={operable}
                        endMonth={endMonth}
                        startMonth={startMonth}
                        export={this.export}
                        search={this.search}
                        searchParams={searchParams}
                        statisticsDsList={statisticsDsList}
                        showStatisticsDs={this.showStatisticsDs}
                        onChange={this.changeSearchParams}
                    />
                    <TableC
                        loading={loading}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        pagination={false}
                        scrollY={scrollY}
                        rowKey="orderChangeReportId"
                        rowClassName={r => r.color || ''}
                    />
                    <SelectStatisticsDs
                        ref={el => this.showStatisticsDsRef = el}
                        statisticsDsList={statisticsDsList}
                        onChange={this.changeSearchParams}
                    />
                </div>
            </div>
        );
    }
}

export default OrderChangeReport;


// WEBPACK FOOTER //
// ./src/components/financeManagement/orderChangeReport/index.js